import React from 'react';
import PropTypes from 'prop-types';

import {Chip, Box, Menu, MenuItem} from 'views/components';
import {Translate} from 'views/module';

const PlaybookPill = (props) => {
  const {
    deletingPlaybookRn,
    onDelete,
    onViewAllPlaybookTasks,
    playbook,
  } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);

  const clearMenu = () => {
    setAnchorEl(null);
  };

  const handleDelete = () => {
    clearMenu();
    onDelete(playbook.playbookRn);
  };

  const handleRedirect = () => {
    window.open(`/playbooks?selectedPlaybookRn=${encodeURIComponent(playbook.playbookRn)}`);
    clearMenu();
  };

  const handleViewAllPlaybookTasks = () => {
    onViewAllPlaybookTasks(playbook.playbookRn);
    clearMenu();
  };

  return (
    <>
      <Chip
        size='small'
        label={`/${playbook.title}${playbook.executionCount > 1 ? ` (${playbook.executionCount})` : ''}`}
        onClick={(event) => setAnchorEl(event.currentTarget)}
        disabled={deletingPlaybookRn === playbook.playbookRn}
        clickable
        icon={
          <Box sx={{
            'borderRadius': '100%',
            'width': 7,
            'height': 7,
            'backgroundColor': '#16A34A',
          }}
          />
        }
        sx={{
          'backgroundColor': '#FDFFFA',
          'border': '1px solid',
          'borderColor': '#16A34A4D',
          'fontFamily': '"Roboto Mono", monospace',
          'color': '#6B6760',
          'fontSize': '12px',
          'display': 'flex',
          'alignItems': 'center',
          'justifyContent': 'center',
          'padding': '13px 0',
          '& .MuiChip-label': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          },
          '& .MuiChip-icon': {
            marginLeft: '10px',
            marginRight: '1px',
          },
        }}
      />
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={clearMenu}
      >
        <MenuItem
          onClick={handleViewAllPlaybookTasks}
        >
          <Translate expression='caregiver.CaregiverDetail.Playbooks.ViewAllTasks' />
        </MenuItem>
        <MenuItem
          onClick={handleRedirect}
        >
          <Translate expression='caregiver.CaregiverDetail.Playbooks.RedirectAction' />
        </MenuItem>
        <MenuItem
          onClick={handleDelete}
          disabled={deletingPlaybookRn === playbook.playbookRn}
        >
          <Translate expression='caregiver.CaregiverDetail.Playbooks.DeleteAction' />
        </MenuItem>
      </Menu>
    </>
  );
};

PlaybookPill.propTypes = {
  deletingPlaybookRn: PropTypes.string,
  onDelete: PropTypes.func,
  onViewAllPlaybookTasks: PropTypes.func.isRequired,
  playbook: PropTypes.shape({
    executionCount: PropTypes.number.isRequired,
    playbookRn: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
};

export default React.memo(PlaybookPill);
